import React, { FunctionComponent, useEffect } from 'react';
import { Presentation } from './presentation';

type Props = {
  isModalOpen: boolean;
  redirectUrl: string;
  isLoginError?: boolean;
  flashMessage?: string;
  fromButton: string;
  recruitmentId?: number;
  eventContentId?: number;
  handleToggleLoginModal: () => void;
  handleChangeModal: (from: 'login' | 'register') => void;
  lineIcon: string;
};

export const Component: FunctionComponent<Props> = ({
  isModalOpen,
  redirectUrl,
  isLoginError,
  flashMessage,
  fromButton,
  recruitmentId,
  eventContentId,
  handleToggleLoginModal,
  handleChangeModal,
  lineIcon,
}) => {
  useEffect(() => {
  if (isModalOpen) {
      const params = new URLSearchParams(window.location.search);
      const isFromLine = params.get('utm_source') === 'line';
      if (isFromLine) {
        setTimeout(() => {
          (document.activeElement as HTMLElement)?.blur();
        }, 100);
      }
    }
  }, [isModalOpen]);

  const handleOauthsLinkClick = (provider: string) => {
    if (fromButton === 'recruitment') {
      sessionStorage.setItem("route_type", "recruitment");
      sessionStorage.setItem("route_recruitment_id", String(recruitmentId));
    }
    if (fromButton === 'event') {
      sessionStorage.setItem("route_type", "event");
      sessionStorage.setItem("route_event_content_id", String(eventContentId));
    }
    window.location.href = `/oauths/${provider}?redirect_url=${redirectUrl}`;
  };

  const handleFormSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    if (fromButton === 'recruitment') {
      sessionStorage.setItem("route_type", "recruitment");
      sessionStorage.setItem("route_recruitment_id", String(recruitmentId));
    }
    if (fromButton === 'event') {
      sessionStorage.setItem("route_type", "event");
      sessionStorage.setItem("route_event_content_id", String(eventContentId));
    }
  };

  const onToggleLoginModal = () => {
    clearSessionRouteType();
    handleToggleLoginModal();
  };

  const onChangeModal = () => {
    clearSessionRouteType();
    handleChangeModal('login');
  };

  const clearSessionRouteType = () => {
    sessionStorage.removeItem('route_type');
  };

  return (
    <Presentation
      isModalOpen={isModalOpen}
      redirectUrl={redirectUrl}
      isLoginError={isLoginError}
      flashMessage={flashMessage}
      fromButton={fromButton}
      handleToggleLoginModal={onToggleLoginModal}
      handleChangeModal={onChangeModal}
      handleOauthsLinkClick={handleOauthsLinkClick}
      handleFormSubmit={handleFormSubmit}
      lineIcon={lineIcon}
    />
  );
};
